export default __webpack_public_path__ + "media/images/coworkr/favicons/icon150-dea224d93ee65a2ee8e84145ce1a85fd.png";